import styled from 'styled-components';

import { getTheme } from '../../util/theme';

// SITE WRAPPER
export const SiteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;

// GLOBAL CONTAINER
export const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 1280px
  padding: 0 .5rem;
`;

// CONTENT WRAPPER
export const ContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

// HEADING WRAPPER
export const HeadingWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: ${getTheme('doubleSpace')};
  text-align: center;

  > :last-child {
    margin-bottom: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Shared/Structural.js